(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("AcrossTabs", [], factory);
	else if(typeof exports === 'object')
		exports["AcrossTabs"] = factory();
	else
		root["AcrossTabs"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _parent = __webpack_require__(1);
	
	var _parent2 = _interopRequireDefault(_parent);
	
	var _child = __webpack_require__(11);
	
	var _child2 = _interopRequireDefault(_child);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AcrossTabs = {
	  Parent: _parent2.default,
	  Child: _child2.default
	};
	
	exports.default = AcrossTabs;
	module.exports = exports['default'];

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _tab = __webpack_require__(2);
	
	var _tab2 = _interopRequireDefault(_tab);
	
	var _tabUtils = __webpack_require__(3);
	
	var _tabUtils2 = _interopRequireDefault(_tabUtils);
	
	var _dom = __webpack_require__(9);
	
	var _dom2 = _interopRequireDefault(_dom);
	
	var _TabStatusEnum = __webpack_require__(6);
	
	var _TabStatusEnum2 = _interopRequireDefault(_TabStatusEnum);
	
	var _WarningTextEnum = __webpack_require__(7);
	
	var _WarningTextEnum2 = _interopRequireDefault(_WarningTextEnum);
	
	var _PostMessageEventNamesEnum = __webpack_require__(4);
	
	var _PostMessageEventNamesEnum2 = _interopRequireDefault(_PostMessageEventNamesEnum);
	
	var _postmessage = __webpack_require__(10);
	
	var _postmessage2 = _interopRequireDefault(_postmessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var heartBeat = void 0,
	    tab = void 0;
	
	// Named Class expression
	var Parent = function () {
	  function Parent(config) {
	    _classCallCheck(this, Parent);
	
	    this.heartBeatInterval = config.heartBeatInterval || 500;
	    // reset tabs with every new Object
	    _tabUtils2.default.closeAll();
	    this.Tab = _tab2.default;
	    this.onHandshakeCallback = config.onHandshakeCallback;
	    this.onPollingCallback = config.onPollingCallback;
	    this.init();
	  }
	
	  _createClass(Parent, [{
	    key: 'startPollingTabs',
	    value: function startPollingTabs() {
	      var _this = this;
	
	      // don't poll if all tabs are in closed states
	      heartBeat = setInterval(function () {
	        var i = void 0,
	            tabs = _tabUtils2.default.getAll();
	
	        for (i = 0; i < tabs.length; i++) {
	          // this.watchStatus(tabs[i]);
	          // check as tab(s) get removed when closed irrespective of heatbeat controller
	          if (tabs[i]) {
	            tabs[i].status = tabs[i].ref.closed ? _TabStatusEnum2.default.CLOSE : _TabStatusEnum2.default.OPEN;
	          }
	        }
	        if (_this.onPollingCallback) {
	          _this.onPollingCallback();
	        }
	      }, this.heartBeatInterval);
	    }
	  }, {
	    key: 'watchStatus',
	    value: function watchStatus(tab) {
	      if (!tab) {
	        return;
	      }
	      var newStatus = tab.ref.closed ? _TabStatusEnum2.default.CLOSE : _TabStatusEnum2.default.OPEN,
	          oldStatus = tab.status;
	
	      if (!newStatus || newStatus === oldStatus) {
	        return;
	      }
	
	      if (oldStatus === _TabStatusEnum2.default.OPEN && newStatus === _TabStatusEnum2.default.CLOSE) {
	        // remove tab from tabUtils
	        _tabUtils2.default._remove(tab);
	      }
	      // Change from CLOSE to OPEN is never gonna happen :)
	    }
	  }, {
	    key: 'customEventUnListener',
	    value: function customEventUnListener(ev) {
	      this.enableElements();
	      if (this.onHandshakeCallback) {
	        this.onHandshakeCallback(ev.detail);
	      }
	    }
	  }, {
	    key: 'addEventListeners',
	    value: function addEventListeners() {
	      var _this2 = this;
	
	      window.removeEventListener('message', _postmessage2.default.onNewTab);
	      window.addEventListener('message', _postmessage2.default.onNewTab);
	
	      window.removeEventListener('show', this.customEventUnListener);
	      window.addEventListener('show', function (ev) {
	        return _this2.customEventUnListener(ev);
	      });
	
	      window.onbeforeunload = function () {
	        _tabUtils2.default.broadCastAll(_PostMessageEventNamesEnum2.default.PARENT_DISCONNECTED);
	      };
	    }
	  }, {
	    key: 'enableElements',
	
	
	    /*
	      API goes here ->
	     */
	    value: function enableElements() {
	      _dom2.default.enable('data-tab-opener');
	    }
	  }, {
	    key: 'getAllTabs',
	    value: function getAllTabs() {
	      return _tabUtils2.default.getAll();
	    }
	  }, {
	    key: 'getOpenedTabs',
	    value: function getOpenedTabs() {
	      return _tabUtils2.default.getOpened();
	    }
	  }, {
	    key: 'getClosedTabs',
	    value: function getClosedTabs() {
	      return _tabUtils2.default.getClosed();
	    }
	  }, {
	    key: 'closeAllTabs',
	    value: function closeAllTabs() {
	      return _tabUtils2.default.closeAll();
	    }
	  }, {
	    key: 'closeTab',
	    value: function closeTab(tab) {
	      return _tabUtils2.default.closeTab(tab);
	    }
	  }, {
	    key: 'broadCastAll',
	    value: function broadCastAll(msg) {
	      return _tabUtils2.default.broadCastAll(msg);
	    }
	  }, {
	    key: 'broadCastTo',
	    value: function broadCastTo(tab, msg) {
	      return _tabUtils2.default.broadCastTo(tab, msg);
	    }
	  }, {
	    key: 'openNewTab',
	    value: function openNewTab(config) {
	      var url = config.url;
	
	      if (!url) {
	        throw new Error(_WarningTextEnum2.default.URL_REQUIRED);
	      }
	
	      tab = new this.Tab();
	      tab.create(config);
	
	      // If polling is already there, don't set it again
	      if (!heartBeat) {
	        this.startPollingTabs();
	      }
	
	      return tab;
	    }
	  }, {
	    key: 'init',
	
	
	    // API ends here
	
	    value: function init() {
	      this.addEventListeners();
	    }
	  }]);
	
	  return Parent;
	}();
	
	module.exports = Parent;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _tabUtils = __webpack_require__(3);
	
	var _tabUtils2 = _interopRequireDefault(_tabUtils);
	
	var _uuid = __webpack_require__(8);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _dom = __webpack_require__(9);
	
	var _dom2 = _interopRequireDefault(_dom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// Named Class expression
	var Tab = function () {
	  function Tab() {
	    _classCallCheck(this, Tab);
	
	    window.name = 'PARENT_TAB';
	    this.init();
	  }
	
	  _createClass(Tab, [{
	    key: 'create',
	    value: function create(config) {
	      this.url = config.url;
	      this.id = _uuid2.default.generate() || _tabUtils2.default.tabs.length + 1;
	      this.name = config.windowName;
	      this.status = 'open';
	      this.ref = window.open(this.url, config.windowName || '_blank', config.windowFeatures);
	
	      _dom2.default.disable('data-tab-opener');
	
	      window.newlyTabOpened = {
	        id: this.id,
	        name: this.name,
	        ref: this.ref
	      };
	
	      _tabUtils2.default.addNew(this);
	
	      return this; // for chaining
	    }
	  }, {
	    key: 'init',
	    value: function init() {}
	  }]);
	
	  return Tab;
	}();
	
	module.exports = Tab;

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _PostMessageEventNamesEnum = __webpack_require__(4);
	
	var _PostMessageEventNamesEnum2 = _interopRequireDefault(_PostMessageEventNamesEnum);
	
	var _array = __webpack_require__(5);
	
	var _array2 = _interopRequireDefault(_array);
	
	var _TabStatusEnum = __webpack_require__(6);
	
	var _TabStatusEnum2 = _interopRequireDefault(_TabStatusEnum);
	
	var _WarningTextEnum = __webpack_require__(7);
	
	var _WarningTextEnum2 = _interopRequireDefault(_WarningTextEnum);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tabUtils = {
	  tabs: []
	};
	
	tabUtils._remove = function (tab) {
	  var index = void 0;
	
	  index = _array2.default.searchByKeyName(tabUtils.tabs, 'id', tab.id, 'index');
	  tabUtils.tabs.splice(index, 1);
	};
	
	tabUtils._preProcessMesage = function (msg) {
	
	  // make msg always an object to support JSON support
	  try {
	    msg = JSON.stringify(msg);
	  } catch (e) {
	    throw new Error(_WarningTextEnum2.default.INVALID_JSON);
	  }
	
	  if (msg.indexOf(_PostMessageEventNamesEnum2.default.PARENT_COMMUNICATED) === -1) {
	    msg = _PostMessageEventNamesEnum2.default.PARENT_COMMUNICATED + msg;
	  }
	
	  return msg;
	};
	
	tabUtils.addNew = function (tab) {
	  tabUtils.tabs.push(tab);
	  return undefined;
	};
	
	tabUtils.getOpened = function () {
	  return tabUtils.tabs.filter(function (tab) {
	    return tab.status === _TabStatusEnum2.default.OPEN;
	  });
	};
	
	tabUtils.getClosed = function () {
	  return tabUtils.tabs.filter(function (tab) {
	    return tab.status === _TabStatusEnum2.default.CLOSE;
	  });
	};
	
	tabUtils.getAll = function () {
	  return tabUtils.tabs;
	};
	
	// it takes id because of some cross origin restriction when passing tab with ref
	tabUtils.closeTab = function (id) {
	  var tab = _array2.default.searchByKeyName(tabUtils.tabs, 'id', id);
	
	  tab && tab.ref.close();
	  return tabUtils;
	  // --tabUtils.tabs.length;
	};
	
	tabUtils.closeAll = function () {
	  var i = void 0;
	
	  for (i = 0; i < tabUtils.tabs.length; i++) {
	    // --tabUtils.tabs.length;
	    tabUtils.tabs[i].ref.close();
	  }
	  return tabUtils;
	};
	
	tabUtils.broadCastAll = function (msg) {
	  var i = void 0,
	      tabs = tabUtils.getAll();
	
	  msg = tabUtils._preProcessMesage(msg);
	
	  for (i = 0; i < tabs.length; i++) {
	    tabs[i].ref.postMessage(msg, '*');
	  }
	};
	
	tabUtils.broadCastTo = function (tab, msg) {
	  var targetedTab = void 0,
	      tabs = tabUtils.getAll();
	
	  msg = tabUtils._preProcessMesage(msg);
	
	  targetedTab = _array2.default.searchByKeyName(tabs, 'id', tab); // TODO: tab.id
	  targetedTab.ref.postMessage(msg, '*');
	};
	
	module.exports = tabUtils;

/***/ },
/* 4 */
/***/ function(module, exports) {

	'use strict';
	
	var PostMessageEventNamesEnum = {
	  LOADED: '__TAB__LOADED_EVENT__',
	  CUSTOM: '__TAB__CUSTOM_EVENT__',
	  ON_BEFORE_UNLOAD: '__TAB__ON_BEFORE_UNLOAD__',
	  PARENT_DISCONNECTED: '__PARENT_DISCONNECTED__',
	  HANDSHAKE_WITH_PARENT: '__HANDSHAKE_WITH_PARENT__',
	  PARENT_COMMUNICATED: '__PARENT_COMMUNICATED__'
	};
	
	module.exports = PostMessageEventNamesEnum;

/***/ },
/* 5 */
/***/ function(module, exports) {

	'use strict';
	
	var arrayUtils = {};
	var returnPreferenceEnum = {
	  INDEX: 'index',
	  OBJECT: 'object',
	  BOTH: 'both'
	};
	
	arrayUtils.searchByKeyName = function (data, key, value, returnPreference) {
	  if (!data || !key) {
	    return {};
	  }
	
	  returnPreference = returnPreference || returnPreferenceEnum[1]; // default to Object
	  var i = void 0,
	      obj = void 0,
	      returnData = void 0,
	      index = -1;
	
	  for (i = 0; i < data.length; i++) {
	    obj = data[i];
	    // Number matching support
	    if (!isNaN(value) && parseInt(obj[key], 10) === parseInt(value, 10)) {
	      index = i;
	      break;
	    } else if (isNaN(value) && obj[key] === value) {
	      // String exact matching support
	      index = i;
	      break;
	    }
	  }
	
	  switch (returnPreference) {
	    case returnPreferenceEnum.INDEX:
	      returnData = index;
	      break;
	    case returnPreferenceEnum.BOTH:
	      returnData = {
	        obj: data[index],
	        index: index
	      };
	      break;
	    case returnPreferenceEnum.OBJECT:
	    default:
	      returnData = data[index];
	      break;
	  }
	
	  return returnData;
	};
	
	module.exports = arrayUtils;

/***/ },
/* 6 */
/***/ function(module, exports) {

	'use strict';
	
	var TabStatusEnum = {
	  OPEN: 'open',
	  CLOSE: 'close'
	};
	
	module.exports = TabStatusEnum;

/***/ },
/* 7 */
/***/ function(module, exports) {

	'use strict';
	
	var WarningTextEnum = {
	  INVALID_JSON: 'Invalid JSON Object!',
	  INVALID_DATA: 'Some wrong message is being sent by Parent.',
	  URL_REQUIRED: 'Url is needed for creating and opening a new window/tab.'
	};
	
	module.exports = WarningTextEnum;

/***/ },
/* 8 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * UUID.js: The RFC-compliant UUID generator for JavaScript.
	 * ES6 port of only `generate` method of UUID by Varun Malhotra under MIT License
	 *
	 * @author  LiosK
	 * @version v3.3.0
	 * @license The MIT License: Copyright (c) 2010-2016 LiosK.
	 */
	
	/** @constructor */
	var UUID = void 0;
	
	UUID = function () {
	  'use strict';
	
	  /** @lends UUID */
	
	  function UUID() {}
	
	  /**
	   * The simplest function to get an UUID string.
	   * @returns {string} A version 4 UUID string.
	   */
	  UUID.generate = function () {
	    var rand = UUID._getRandomInt,
	        hex = UUID._hexAligner;
	
	    // ["timeLow", "timeMid", "timeHiAndVersion", "clockSeqHiAndReserved", "clockSeqLow", "node"]
	    return hex(rand(32), 8) + // time_low
	    '-' + hex(rand(16), 4) + // time_mid
	    '-' + hex(0x4000 | rand(12), 4) + // time_hi_and_version
	    '-' + hex(0x8000 | rand(14), 4) + // clock_seq_hi_and_reserved clock_seq_low
	    '-' + hex(rand(48), 12); // node
	  };
	
	  /**
	   * Returns an unsigned x-bit random integer.
	   * @param {int} x A positive integer ranging from 0 to 53, inclusive.
	   * @returns {int} An unsigned x-bit random integer (0 <= f(x) < 2^x).
	   */
	  UUID._getRandomInt = function (x) {
	    if (x < 0) {
	      return NaN;
	    }
	    if (x <= 30) {
	      return 0 | Math.random() * (1 << x);
	    }
	    if (x <= 53) {
	      return (0 | Math.random() * (1 << 30)) + (0 | Math.random() * (1 << x - 30)) * (1 << 30);
	    }
	
	    return NaN;
	  };
	
	  /**
	   * Returns a function that converts an integer to a zero-filled string.
	   * @param {int} radix
	   * @returns {function(num&#44; length)}
	   */
	  UUID._getIntAligner = function (radix) {
	    return function (num, length) {
	      var str = num.toString(radix),
	          i = length - str.length,
	          z = '0';
	
	      for (; i > 0; i >>>= 1, z += z) {
	        if (i & 1) {
	          str = z + str;
	        }
	      }
	      return str;
	    };
	  };
	
	  UUID._hexAligner = UUID._getIntAligner(16);
	
	  /**
	   * Returns UUID string representation.
	   * @returns {string} {@link UUID#hexString}.
	   */
	  UUID.prototype.toString = function () {
	    return this.hexString;
	  };
	
	  return UUID;
	}(UUID);
	
	module.exports = UUID;

/***/ },
/* 9 */
/***/ function(module, exports) {

	'use strict';
	
	var domUtils = {
	  disable: function disable(selector) {
	    if (!selector) {
	      return;
	    }
	
	    var i = void 0,
	        ATOpenersElems = document.querySelectorAll('[' + selector + ']');
	
	    for (i = 0; i < ATOpenersElems.length; i++) {
	      ATOpenersElems[i].setAttribute('disabled', 'disabled');
	    }
	  },
	  enable: function enable(selector) {
	    if (!selector) {
	      return;
	    }
	
	    var i = void 0,
	        ATOpenersElems = document.querySelectorAll('[' + selector + ']');
	
	    for (i = 0; i < ATOpenersElems.length; i++) {
	      ATOpenersElems[i].removeAttribute('disabled');
	    }
	  }
	};
	
	module.exports = domUtils;

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _array = __webpack_require__(5);
	
	var _array2 = _interopRequireDefault(_array);
	
	var _tabUtils = __webpack_require__(3);
	
	var _tabUtils2 = _interopRequireDefault(_tabUtils);
	
	var _WarningTextEnum = __webpack_require__(7);
	
	var _WarningTextEnum2 = _interopRequireDefault(_WarningTextEnum);
	
	var _PostMessageEventNamesEnum = __webpack_require__(4);
	
	var _PostMessageEventNamesEnum2 = _interopRequireDefault(_PostMessageEventNamesEnum);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PostMessageListener = {};
	
	PostMessageListener._onLoad = function () {
	  var data = void 0;
	  var tabInfo = {
	    id: window.newlyTabOpened.id,
	    name: window.newlyTabOpened.name,
	    parentName: window.name
	  };
	
	  if (window.newlyTabOpened) {
	    try {
	      data = _PostMessageEventNamesEnum2.default.HANDSHAKE_WITH_PARENT;
	      data += JSON.stringify(tabInfo);
	      window.newlyTabOpened.ref.postMessage(data, '*');
	    } catch (e) {
	      throw new Error(_WarningTextEnum2.default.INVALID_JSON);
	    }
	  }
	};
	
	PostMessageListener._onCustomMessage = function (data) {
	  // CustomEvent not supported in IE
	  var event = new CustomEvent('show', { 'detail': data });
	
	  window.dispatchEvent(event);
	  window.newlyTabOpened = null;
	};
	
	PostMessageListener._onBeforeUnload = function (data) {
	  var id = data.split(_PostMessageEventNamesEnum2.default.ON_BEFORE_UNLOAD)[1],
	      tabs = void 0;
	
	  if (_tabUtils2.default.tabs.length) {
	    tabs = _tabUtils2.default.getAll();
	    window.newlyTabOpened = _array2.default.searchByKeyName(tabs, 'id', id) || window.newlyTabOpened;
	  }
	};
	
	PostMessageListener.onNewTab = function (message) {
	  var data = message.data;
	
	  if (!_tabUtils2.default.tabs.length) {
	    return;
	  }
	
	  if (data === _PostMessageEventNamesEnum2.default.LOADED) {
	    PostMessageListener._onLoad();
	  } else if (data.indexOf(_PostMessageEventNamesEnum2.default.CUSTOM) > -1) {
	    PostMessageListener._onCustomMessage(data);
	  } else if (data.indexOf(_PostMessageEventNamesEnum2.default.ON_BEFORE_UNLOAD) > -1) {
	    PostMessageListener._onBeforeUnload(data);
	  }
	};
	
	module.exports = PostMessageListener;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _PostMessageEventNamesEnum = __webpack_require__(4);
	
	var _PostMessageEventNamesEnum2 = _interopRequireDefault(_PostMessageEventNamesEnum);
	
	var _WarningTextEnum = __webpack_require__(7);
	
	var _WarningTextEnum2 = _interopRequireDefault(_WarningTextEnum);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var sessionStorageKey = '__vwo_tab_id__';
	
	// Named Class expression
	var Child = function () {
	  function Child(config) {
	    _classCallCheck(this, Child);
	
	    this.config = config || {};
	
	    this.handshakeExpiryLimit = this.config.handshakeExpiryLimit || 5000;
	
	    this.tabName = window.name;
	    this.tabId = null;
	    this.tabParentName = null;
	
	    // this.init();
	  }
	
	  _createClass(Child, [{
	    key: '_isSessionStorage',
	    value: function _isSessionStorage() {
	      if (window.sessionStorage) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: '_getData',
	    value: function _getData() {
	      if (!this.isSessionStorageSupported) {
	        return false;
	      }
	
	      return sessionStorage.getItem(sessionStorageKey);
	    }
	  }, {
	    key: '_setData',
	    value: function _setData(dataReceived) {
	      if (!this.isSessionStorageSupported) {
	        return false;
	      }
	
	      sessionStorage.setItem(sessionStorageKey, dataReceived);
	      return true;
	    }
	  }, {
	    key: '_restoreData',
	    value: function _restoreData() {
	      if (!this.isSessionStorageSupported) {
	        return false;
	      }
	
	      if (this.isSessionStorageSupported) {
	        var storedData = this._getData();
	
	        this.parseData(storedData);
	        /*if (this.config.onInitialize) {
	          this.config.onInitialize();
	        }*/
	      }
	    }
	  }, {
	    key: 'onCommunication',
	    value: function onCommunication(message) {
	      var _this = this;
	
	      var dataReceived = void 0,
	          data = message.data;
	
	      // cancel timeout
	      window.clearTimeout(this.timeout);
	
	      if (data.indexOf(_PostMessageEventNamesEnum2.default.PARENT_DISCONNECTED) > -1) {
	        // callback
	        if (this.config.onParentDisconnect) {
	          this.config.onParentDisconnect();
	        }
	        // remove postMessage listener since no Parent is there to communicate with
	        window.removeEventListener('message', function (evt) {
	          return _this.onHandShake(evt);
	        });
	        return;
	      }
	
	      if (data.indexOf(_PostMessageEventNamesEnum2.default.HANDSHAKE_WITH_PARENT) > -1) {
	        dataReceived = data.split(_PostMessageEventNamesEnum2.default.HANDSHAKE_WITH_PARENT)[1];
	
	        this._setData(dataReceived);
	        this.parseData(dataReceived);
	
	        this.sendMessageToParent(_PostMessageEventNamesEnum2.default.CUSTOM + this.tabId);
	
	        if (this.config.onInitialize) {
	          this.config.onInitialize();
	        }
	      }
	
	      if (data.indexOf(_PostMessageEventNamesEnum2.default.PARENT_COMMUNICATED) > -1) {
	        dataReceived = data.split(_PostMessageEventNamesEnum2.default.PARENT_COMMUNICATED)[1];
	
	        if (this.config.onParentCommunication) {
	          this.config.onParentCommunication(dataReceived);
	        }
	      }
	    }
	  }, {
	    key: 'parseData',
	    value: function parseData(dataReceived) {
	      var actualData = void 0;
	
	      // Expecting JSON data
	      try {
	        actualData = JSON.parse(dataReceived);
	        this.tabId = actualData && actualData.id;
	        this.tabParentName = actualData && actualData.parentName;
	      } catch (e) {
	        throw new Error(_WarningTextEnum2.default.INVALID_DATA);
	      };
	    }
	  }, {
	    key: 'addListeners',
	    value: function addListeners() {
	      var _this2 = this;
	
	      window.onbeforeunload = function (evt) {
	        _this2.sendMessageToParent(_PostMessageEventNamesEnum2.default.ON_BEFORE_UNLOAD + _this2.tabId);
	      };
	
	      window.removeEventListener('message', function (evt) {
	        return _this2.onCommunication(evt);
	      });
	      window.addEventListener('message', function (evt) {
	        return _this2.onCommunication(evt);
	      });
	    }
	  }, {
	    key: 'setHandshakeExpiry',
	    value: function setHandshakeExpiry() {
	      var _this3 = this;
	
	      return setTimeout(function () {
	        if (_this3.config.onHandShakeExpiry) {
	          _this3.config.onHandShakeExpiry();
	        }
	      }, this.handshakeExpiryLimit);
	    }
	
	    // API starts here ->
	
	  }, {
	    key: 'sendMessageToParent',
	    value: function sendMessageToParent(msg) {
	      if (window.top.opener) {
	        window.top.opener.postMessage(msg, '*');
	      }
	    }
	  }, {
	    key: 'getTabInfo',
	    value: function getTabInfo() {
	      return {
	        id: this.tabId,
	        name: this.tabName,
	        parentName: this.tabParentName
	      };
	    }
	  }, {
	    key: 'init',
	
	    // API ends here ->
	
	    value: function init() {
	      if (this.config.onReady) {
	        this.config.onReady();
	      }
	      this.isSessionStorageSupported = this._isSessionStorage();
	      this.sendMessageToParent(_PostMessageEventNamesEnum2.default.LOADED);
	      this.addListeners();
	      this._restoreData();
	      this.timeout = this.setHandshakeExpiry();
	    }
	  }]);
	
	  return Child;
	}();
	
	module.exports = Child;

/***/ }
/******/ ])
});
;


/** WEBPACK FOOTER **
 ** across-tabs.min.js
 **/